
import React from 'react';
import { NetworkDevice, NodeType } from '../types';

interface Props {
  device: NetworkDevice;
  isSelected: boolean;
  onClick: (id: string) => void;
}

const icons: Record<NodeType, React.ReactNode> = {
  PC: (
    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  SWITCH: (
    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
    </svg>
  ),
  ROUTER: (
    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="9" strokeWidth={2} />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h8m-4-4v8" />
    </svg>
  ),
  ISP: (
    <div className="relative flex items-center justify-center">
      <div className="absolute w-12 h-12 bg-blue-400 rounded-full blur-md opacity-20 animate-pulse"></div>
      <svg className="w-12 h-12 relative z-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" strokeWidth={1.5} />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    </div>
  )
};

const DeviceNode: React.FC<Props> = ({ device, isSelected, onClick }) => {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        onClick(device.id);
      }}
      className={`w-20 h-20 flex flex-col items-center justify-center rounded-xl transition-all transform z-10 select-none cursor-pointer relative ${
        isSelected ? 'bg-blue-100 ring-4 ring-blue-400 scale-105 shadow-xl' : 'bg-white shadow-md hover:shadow-lg'
      } ${device.type === 'ISP' ? 'border-2 border-blue-200 bg-blue-50/50 shadow-blue-100 shadow-lg' : ''}`}
    >
      {device.type === 'PC' && !device.firewallDisabled && (
        <div className="absolute -top-1 -right-1 text-white bg-red-600 rounded-full p-1.5 shadow-lg border-2 border-white z-20 animate-pulse" title="Firewall Menghadang!">
           <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
             <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
           </svg>
        </div>
      )}

      <div className={`${isSelected ? 'text-blue-600' : device.type === 'ISP' ? 'text-blue-600' : 'text-slate-600'}`}>
        {icons[device.type]}
      </div>
      
      <span className="text-[8px] font-black mt-1 uppercase tracking-tighter text-slate-400">
        {device.type === 'ISP' ? 'Internet' : device.type}
      </span>
      
      <span className="text-[10px] font-bold text-slate-800 truncate w-full px-1 text-center leading-tight">
        {device.name}
      </span>

      {(device.ip || (device.type === 'ROUTER' && device.ipWan)) && (
        <span className="text-[7px] text-blue-700 mt-1 font-mono font-black bg-blue-50 px-1 rounded border border-blue-200">
          {device.type === 'ROUTER' ? (device.ipWan || 'WAN') : device.ip}
        </span>
      )}
      
      {isSelected && (
        <div className="absolute -bottom-6 left-0 right-0 text-center">
          <span className="bg-blue-600 text-white text-[8px] px-2 py-0.5 rounded-full font-black uppercase shadow-lg">DIPILIH</span>
        </div>
      )}
    </div>
  );
};

export default DeviceNode;
